(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widget-amtc-fund-comparison", [], factory);
	else if(typeof exports === 'object')
		exports["widget-amtc-fund-comparison"] = factory();
	else
		root["widget-amtc-fund-comparison"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1021);

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Spacings = exports.Spacings = {
	    NONE: 'none',
	    SMALL: 'small',
	    MEDIUM: 'medium',
	    BIG: 'big'
	};
	Object.freeze(Spacings);
	
	var SPACING_OPTIONS = exports.SPACING_OPTIONS = [{ label: 'None', value: Spacings.NONE }, { label: 'Spacing small', value: Spacings.SMALL }, { label: 'Spacing medium', value: Spacings.MEDIUM }, { label: 'Spacing big', value: Spacings.BIG }];
	
	var SPACING_PREF = exports.SPACING_PREF = 'spacing';

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Containers = exports.Containers = {
	    NONE: 'none',
	    REGULAR: 'regular'
	};
	Object.freeze(Containers);
	
	var CONTAINER_OPTIONS = exports.CONTAINER_OPTIONS = [{ label: 'None', value: Containers.NONE }, { label: 'Regular', value: Containers.REGULAR }];
	
	var CONTAINER_PREF = exports.CONTAINER_PREF = 'container';

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(1022);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	App.Widgets.setWidgetStarterInNamespace('WidgetAmtcFundComparison', _controller2.default);

/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(1023);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	var _appFundComparison = __webpack_require__(1026);
	
	var _appFundComparison2 = _interopRequireDefault(_appFundComparison);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Controller = function (_AbstractIceContentCo) {
	    _inherits(Controller, _AbstractIceContentCo);
	
	    function Controller(widget) {
	        _classCallCheck(this, Controller);
	
	        var _this = _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, widget));
	
	        _this.init(widget);
	        return _this;
	    }
	
	    _createClass(Controller, [{
	        key: 'init',
	        value: function init(widget) {
	            var helpers = new _appFundComparison2.default();
	            //Configurable text
	            var chooseCurrencyText = decodeURI(widget.getPreference('chooseCurrencyText'));
	            var chooseFundsText = decodeURI(widget.getPreference('chooseFundsText'));
	            var cantCompareText = decodeURI(widget.getPreference('cantCompareText'));
	            var ddDefaultText = decodeURI(widget.getPreference('ddDefaultText'));
	
	            var compareEndpoint = decodeURI(widget.getPreference('compareEndPoint'));
	            var compareContentEndpoint = decodeURI(widget.getPreference('compareContentEndpoint'));
	            var compareProcessorEndpoint = decodeURI(widget.getPreference('compareProcessorEndpoint'));
	            var compareProcessorHeaders = decodeURI(widget.getPreference('compareProcessorHeaders'));
	
	            var fundClassText = decodeURI(widget.getPreference('fundClassText'));
	
	            var startSessionEndpoint = "services/rest/routeProcessor";
	            var startSessionHeaders = {
	                intSvcName: "sis/amtc",
	                service: "startSessionAPI"
	            };
	            //Start Angular JS
	            var moduleFundComparison = angular.module("moduleFundComparison", []);
	            var initialFund = helpers.getFundIdParameters(window.location.search, "fundId");
	
	            var fundComparisonController = function fundComparisonController($scope) {
	                //Apply Configurations
	                $scope.chooseCurrencyText = chooseCurrencyText;
	                $scope.chooseFundsText = chooseFundsText;
	                $scope.cantCompareText = cantCompareText;
	                $scope.ddDefaultText = ddDefaultText;
	
	                //Start Session
	                helpers.startSession(startSessionEndpoint, startSessionHeaders).then(function (result) {
	                    sessionStorage.setItem("s_key", result.transactionId);
	                }).catch(function (err) {
	                    console.log("Error fetching the funds, no connection");
	                });
	
	                //Toggle Show more and show less
	                $scope.showThis = [false, false, false];
	                $scope.toggleDetails = function (i) {
	                    if ($scope.showThis[i]) {
	                        $scope.showThis[i] = false;
	                    } else {
	                        $scope.showThis[i] = true;
	                    }
	                };
	
	                //fetch all the funds from the portal content
	                $scope.allFunds = [];
	                var urlContent = "/services/rest/amtc/content";
	                var amtcContentProductsPath = compareContentEndpoint;
	                var amtcContentProcessorPath = compareProcessorEndpoint;
	                var amtcContentProcessorHeaders = compareProcessorHeaders;
	
	                $scope.defaultLoader = true; //display Loader on Initialize
	                // helpers.getAmtcProducts(urlContent, amtcContentProductsPath).then((result) => {
	                //     $scope.allFunds =result.productList;
	                //     $scope.$apply(() => {
	                //         $scope.defaultLoader = false;
	                //         $scope.loadInitialFund();
	                //     });compareContentEndpoint
	                // }).catch((err) => {
	                //     console.log("Error fetching the funds, no connection");
	                // });
	
	                //V2
	                helpers.getAmtcProductsV2(amtcContentProductsPath, amtcContentProcessorPath, amtcContentProcessorHeaders).then(function (result) {
	                    $scope.allFunds = result.productList;
	                    $scope.$apply(function () {
	                        $scope.defaultLoader = false;
	                        $scope.loadInitialFund();
	                    });
	                }).catch(function (err) {
	                    console.log("Error fetching the funds, no connection");
	                });
	
	                //Load the fund from query params
	                $scope.loadInitialFund = function () {
	                    if (initialFund) {
	                        var initFund = "";
	                        $scope.allFunds.map(function (a) {
	                            if (a.fundID === initialFund) {
	                                initFund = a;
	                            }
	                        });
	                        $scope.checkPreselected(initFund.baseCurrency);
	                        $scope.setSelected(initFund);
	                    }
	                };
	
	                $scope.selectedFundComps = [];
	
	                //Check for Preselection
	                $scope.currency = "";
	                $scope.temp = "";
	                $scope.checkPreselected = function (currency) {
	                    $scope.temp = currency;
	                    //if($scope.currency==""){
	                    $scope.currency = currency;
	                    $scope.filterCurrency();
	                    // }else{
	                    //     $scope.showDialog=true;
	                    // }
	                };
	
	                $scope.closeDialog = function (ans) {
	                    if (ans) {
	                        $scope.currency = $scope.temp;
	                        $scope.filterCurrency();
	                    }
	                    //$scope.showDialog=false;
	                };
	
	                //filtering by Currency
	                $scope.filteredByCurrency = [];
	                $scope.filterCurrency = function () {
	                    $scope.filteredByCurrency = [];
	                    $scope.allFunds.map(function (a) {
	                        if ($scope.currency === a.baseCurrency) {
	                            $scope.filteredByCurrency.push(a);
	                        }
	                    });
	                    //console.log("Filtered by Currency",$scope.filteredByCurrency);
	
	                    if ($scope.selectedFundComps.length > 0) {
	                        $scope.selectedFundComps = [];
	                    }
	                    $scope.filterByAssetClass();
	                };
	
	                //filtering by assetClass
	
	                $scope.assetClasses = JSON.parse(fundClassText); //asset class from widget properties
	
	                $scope.moneyMarketFunds = [];
	                $scope.equityFunds = [];
	                $scope.bondFunds = [];
	                $scope.balancedfunds = [];
	
	                $scope.filterByAssetClass = function () {
	                    //Clear First
	                    $scope.assetClasses.map(function (a) {
	                        a.funds = [];
	                    });
	                    $scope.filteredByCurrency.map(function (a) {
	                        // console.log($scope.assetClasses[0].fundClassID);
	                        if (a.assetClass === $scope.assetClasses[0].fundClassID) {
	                            $scope.assetClasses[0].funds.push(a);
	                        }
	                        if (a.assetClass === $scope.assetClasses[1].fundClassID) {
	                            $scope.assetClasses[1].funds.push(a);
	                        }
	                        if (a.assetClass === $scope.assetClasses[2].fundClassID) {
	                            $scope.assetClasses[2].funds.push(a);
	                        }
	                        if (a.assetClass === $scope.assetClasses[3].fundClassID) {
	                            $scope.assetClasses[3].funds.push(a);
	                        }
	                    });
	
	                    //console.log($scope.assetClasses);
	                };
	
	                //Selected Funds
	                $scope.setSelected = function (fund) {
	                    helpers.apiRequestCanceller();
	                    $scope.displayShowGraphBtn = true;
	                    $scope.showTable = false;
	                    $scope.selectedFundComps.push(fund);
	                    $scope.filterSelected(fund.assetClass, fund.fundID);
	                };
	
	                //Filter array for second and third fund selection
	                //Remove the fund once it is selected
	                $scope.secondDropDownFunds = [];
	                $scope.filterForSecondDropdown = function (filteredAssetClass) {
	                    var filteredFunds = filteredAssetClass[0].funds.filter(function (e) {
	                        return e.fundID !== $scope.selectedFundComps[0].fundID;
	                    });
	                    $scope.secondDropDownFunds = filteredAssetClass;
	                    $scope.secondDropDownFunds[0].funds = filteredFunds;
	                };
	
	                $scope.thirdDropDownFunds = [];
	                $scope.filterForThirdDropdown = function (filteredAssetClass) {
	                    var filteredFunds = filteredAssetClass[0].funds.filter(function (e) {
	                        return e.fundID !== $scope.selectedFundComps[0].fundID && e.fundID != $scope.selectedFundComps[1].fundID;
	                    });
	                    $scope.thirdDropDownFunds = filteredAssetClass;
	                    $scope.thirdDropDownFunds[0].funds = filteredFunds;
	                };
	
	                $scope.filterSelected = function (fundClass, fundID) {
	                    //Filter By Fund Class
	                    $scope.filterByAssetClass();
	                    var filteredAssetClass = $scope.assetClasses.filter(function (e) {
	                        return e.fundClassID === fundClass;
	                    });
	                    if ($scope.selectedFundComps.length == 1) {
	                        $scope.filterForSecondDropdown(filteredAssetClass);
	                    } else {
	                        $scope.filterForSecondDropdown(filteredAssetClass);
	                        $scope.filterForThirdDropdown(filteredAssetClass);
	                    }
	                };
	
	                $scope.resetSelection = function (id) {
	                    $scope.filterSelected($scope.selectedFundComps[id].assetClass, $scope.selectedFundComps[id].fundID);
	                };
	
	                $scope.closeIndex1 = false;
	                $scope.closeIndex2 = false;
	                $scope.enableTransition = true;
	                $scope.removeFund = function (fund) {
	                    helpers.apiRequestCanceller();
	                    $scope.displayShowGraphBtn = true;
	                    $scope.showTable = false;
	                    $scope.enableTransition = true;
	                    $scope.selectedFundComps.splice(fund, 1);
	                    if (fund == "all") {
	                        $scope.selectedFundComps = [];
	                        $scope.filterCurrency();
	                    } else {
	                        if ($scope.selectedFundComps.length > 0) {
	                            if (fund == 0) {
	                                $scope.resetSelection(fund);
	                            } else {
	                                $scope.resetSelection(fund - 1);
	                            }
	                        } else {
	                            $scope.filterByAssetClass();
	                        }
	
	                        if (fund == 1) {
	                            $scope.showSecondDropdown = false;
	                        }
	                        if (fund == 2) {
	                            $scope.showThirdDropdown = false;
	                        }
	                    }
	
	                    // setTimeout(()=>{
	                    //     $scope.$apply(() => {
	                    //         if(fund==0){
	                    //             $scope.closeIndex1=true;
	                    //             $scope.closeIndex2=true;
	                    //         }
	                    //         if(fund==1){
	                    //             $scope.closeIndex1 =false;
	                    //             $scope.closeIndex2=true;
	                    //         }
	                    //     });
	                    // },300);
	
	                    // $scope.funds = $scope.funds.filter(function (arr) {
	                    //     if (arr.fundID == fund) {
	                    //         arr.selected = false;
	                    //     }
	                    //     return arr;
	                    // });
	                    // var selectedFunds = $scope.funds.filter(function (arr) {
	                    //     return arr.selected == true;
	                    // });
	
	                    // setTimeout(()=>{
	                    //     $scope.$apply(() => {
	                    //         $scope.selectedFundComps.splice(fund,1);
	                    //         $scope.enableTransition=false;
	                    //         $scope.closeIndex1 =false;
	                    //         $scope.closeIndex2 =false;
	                    //     });
	                    // },700);
	
	                };
	
	                $scope.showSecondDropdown = false;
	                $scope.showThirdDropdown = false;
	
	                $scope.showFundClass = false;
	                $scope.toggleDisplaySecondSelect = function (val) {
	                    $scope.showSecondDropdown = true;
	
	                    if (val) {
	                        $scope.showFundClass = false; //hide onBlur
	                        $scope.showSecondDropdown = false;
	                    } else {
	                        $scope.showFundClass = !$scope.showFundClass;
	                        $scope.showSecondDropdown = true;
	                    }
	                };
	
	                $scope.showFunds = false;
	                $scope.toggleDisplayThirdSelect = function (val) {
	                    $scope.showThirdDropdown = true;
	
	                    if (val) {
	                        $scope.showFunds = false; //hide onBlur
	                        $scope.showThirdDropdown = false;
	                    } else {
	                        $scope.showFunds = !$scope.showFunds;
	                        $scope.showThirdDropdown = true;
	                    }
	                };
	
	                /* #region  Dropdown Toggle */
	                $scope.showRiskList = false;
	                $scope.toggleDisplayFirstFund = function (val) {
	                    if (val) {
	                        $scope.showRiskList = false; //hide onBlur
	                    } else {
	                        $scope.showRiskList = !$scope.showRiskList;
	                    }
	                };
	                /* #endregion */
	
	                $scope.showTable = false;
	
	                $scope.ytd = true;
	                $scope.oneYear = false;
	                $scope.threeYears = false;
	                $scope.fiveYears = false;
	                $scope.ytdDef = false;
	                $scope.oneYearDef = true;
	                $scope.threeYearsDef = true;
	                $scope.fiveYearsDef = true;
	                $scope.displayLoader = false;
	
	                $scope.showDialogCompare0 = false;
	                $scope.showDialogCompare1 = false;
	                $scope.showDialogCompare2 = false;
	                $scope.fundNameComp0 = "fund";
	                $scope.fundHorizonComp0 = "horizon";
	                $scope.fundInceptionDateComp0 = "inception Date";
	                $scope.fundNameComp1 = "fund";
	                $scope.fundHorizonComp1 = "horizon";
	                $scope.fundInceptionDateComp1 = "inception Date";
	                $scope.fundNameComp2 = "fund";
	                $scope.fundHorizonComp2 = "horizon";
	                $scope.fundInceptionDateComp2 = "inception Date";
	                $scope.closeDialogCompare = function (i) {
	                    if (i == 0) {
	                        $scope.showDialogCompare0 = false;
	                    }
	                    if (i == 1) {
	                        $scope.showDialogCompare1 = false;
	                    }
	                    if (i == 2) {
	                        $scope.showDialogCompare2 = false;
	                    }
	                };
	
	                $scope.displayShowGraphBtn = true;
	
	                $scope.hideChart = false;
	                $scope.hideChartClick = function () {
	                    $scope.displayShowGraphBtn = true;
	                    $scope.showTable = false;
	                };
	
	                $scope.blockCall = false;
	                $scope.compareFunds = function (term) {
	                    //ToDo: Dialog box for fund with incomplete data
	                    if (!$scope.blockCall) {
	                        $scope.displayShowGraphBtn = false;
	                        $scope.showTable = true; //Display Selected Fund Table
	                        var horizon = term;
	                        var fundIDSelected = Object.values($scope.selectedFundComps).map(function (e) {
	                            return e.fundID;
	                        });
	
	                        var urlMarketValue = compareEndpoint;
	                        $scope.displayLoader = true;
	
	                        $scope.blockCall = true;
	                        helpers.getMarketValue(fundIDSelected, horizon, urlMarketValue).then(function (result) {
	                            var fundResult = result;
	                            var fundObject = [];
	                            for (var x = 0; x < fundResult.funds.length; x++) {
	                                var values = Object.values(fundResult.funds[x].navpuList).map(function (key) {
	                                    var dformat = new Date(key.dateValue);
	                                    var month = dformat.getMonth() + 1;
	                                    var day = dformat.getDate();
	                                    var year = dformat.getFullYear();
	                                    var format = month + "/" + day + "/" + year;
	                                    return { t: format, y: parseInt(key.marketValue) };
	                                });
	
	                                if (!fundResult.funds[x].isInvestmentTermValid && horizon <= 5 && horizon != 0) {
	                                    if (x == 0) {
	                                        $scope.showDialogCompare0 = true;
	                                        $scope.fundNameComp0 = fundResult.funds[x].fundName;
	                                        $scope.fundHorizonComp0 = horizon;
	                                        $scope.fundInceptionDateComp0 = fundResult.funds[x].inceptionDate;
	                                    }
	                                    if (x == 1) {
	                                        $scope.showDialogCompare1 = true;
	                                        $scope.fundNameComp1 = fundResult.funds[x].fundName;
	                                        $scope.fundHorizonComp1 = horizon;
	                                        $scope.fundInceptionDateComp1 = fundResult.funds[x].inceptionDate;
	                                    }
	                                    if (x == 2) {
	                                        $scope.showDialogCompare2 = true;
	                                        $scope.fundNameComp2 = fundResult.funds[x].fundName;
	                                        $scope.fundHorizonComp2 = horizon;
	                                        $scope.fundInceptionDateComp2 = fundResult.funds[x].inceptionDate;
	                                    }
	
	                                    $scope.hideChart = false;
	                                    fundObject.push({
	                                        fundName: fundResult.funds[x].fundName,
	                                        fundCurr: $scope.selectedFundComps[x].baseCurrency,
	                                        fundData: values
	                                    });
	                                    helpers.loadChart(fundObject);
	                                } else {
	                                    fundObject.push({
	                                        fundName: fundResult.funds[x].fundName,
	                                        fundCurr: $scope.selectedFundComps[x].baseCurrency,
	                                        fundData: values
	                                    });
	                                }
	                            }
	                            $scope.$apply(function () {
	                                $scope.displayLoader = false;
	                                $scope.blockCall = false;
	                            });
	                            helpers.loadChart(fundObject);
	                            helpers.startSession(startSessionEndpoint, startSessionHeaders).then(function (result) {
	                                sessionStorage.setItem("s_key", result.transactionId);
	                            }).catch(function (err) {
	                                console.log("Error starting session, no connection");
	                            });
	                        }).catch(function (err) {
	                            helpers.startSession(startSessionEndpoint, startSessionHeaders).then(function (result) {
	                                sessionStorage.setItem("s_key", result.transactionId);
	                            }).catch(function (err) {
	                                console.log("Error starting session, no connection");
	                            });
	                            $scope.$apply(function () {
	                                $scope.displayLoader = false;
	                                $scope.blockCall = false;
	                            });
	
	                            //FOR DEBUGGING Purposes only, will remove
	                            // var mockChartData = [
	                            //     { fundName: "testfundA", fundCurr: "Peso", fundData: [{ t: "06/25/2018", y: 10000 }, { t: "08/25/2018", y: 10000 }, { t: "09/25/2018", y: 10000 }] },
	                            //     { fundName: "testfundB", fundCurr: "Peso", fundData: [{ t: "06/25/2018", y: 8000 }, { t: "09/25/2018", y: 9000 }, { t: "10/25/2018", y: 8000 }] },
	                            //     { fundName: "testfundC", fundCurr: "Peso", fundData: [{ t: "06/25/2018", y: 7000 }, { t: "07/25/2018", y: 8000 }, { t: "10/20/2018", y: 5000 }] }
	                            // ];
	                            // helpers.loadChart(mockChartData);
	                        });
	                        if (term == 0) {
	                            $scope.ytd = true;
	                            $scope.oneYear = false;
	                            $scope.threeYears = false;
	                            $scope.fiveYears = false;
	                            $scope.ytdDef = false;
	                            $scope.oneYearDef = true;
	                            $scope.threeYearsDef = true;
	                            $scope.fiveYearsDef = true;
	                        } else if (term == 1) {
	                            $scope.ytd = false;
	                            $scope.oneYear = true;
	                            $scope.threeYears = false;
	                            $scope.fiveYears = false;
	                            $scope.ytdDef = true;
	                            $scope.oneYearDef = false;
	                            $scope.threeYearsDef = true;
	                            $scope.fiveYearsDef = true;
	                        } else if (term == 3) {
	                            $scope.ytd = false;
	                            $scope.oneYear = false;
	                            $scope.threeYears = true;
	                            $scope.fiveYears = false;
	                            $scope.ytdDef = true;
	                            $scope.oneYearDef = true;
	                            $scope.threeYearsDef = false;
	                            $scope.fiveYearsDef = true;
	                        } else if (term == 5) {
	                            $scope.ytd = false;
	                            $scope.oneYear = false;
	                            $scope.threeYears = false;
	                            $scope.fiveYears = true;
	                            $scope.ytdDef = true;
	                            $scope.oneYearDef = true;
	                            $scope.threeYearsDef = true;
	                            $scope.fiveYearsDef = false;
	                        }
	                    }
	                };
	            };
	
	            var toTitleCaseFilter = function toTitleCaseFilter() {
	                return function (value) {
	                    if (value) {
	                        return helpers.toTitleCase(value);
	                    } else {
	                        return "";
	                    }
	                };
	            };
	            var pluralizedYear = function pluralizedYear() {
	                return function (value) {
	                    if (value > 1) {
	                        return value + " yrs";
	                    } else {
	                        return value + " yr";
	                    }
	                };
	            };
	            var removePortalserver = function removePortalserver() {
	                return function (value) {
	                    return '/' + App.Utils.Helpers.getRelativePath() + value;
	                };
	            };
	            /* #region  AngularJs Loader */
	            moduleFundComparison.controller('FundComparisonController', ['$scope', fundComparisonController]);
	            moduleFundComparison.filter('toTitleCase', toTitleCaseFilter);
	            moduleFundComparison.filter('pluralizedYear', pluralizedYear);
	            moduleFundComparison.filter('removePortalserver', removePortalserver);
	            moduleFundComparison.directive("ngFundComparisonPartial", function () {
	                return {
	                    template: __webpack_require__(1027)
	                };
	            });
	            angular.element(document.getElementById('fundComparison')).ready(function () {
	                var fundComparisonTemplate = document.createElement('ng-fund-comparison-partial');
	                document.getElementById("desclaimer").setAttribute("ng-show", "showTable");
	                if (document.getElementById('partial-fund-comparison')) {
	                    document.getElementById('partial-fund-comparison').appendChild(fundComparisonTemplate);
	                }
	
	                angular.bootstrap(document.getElementById("amtcFundComparison"), ['moduleFundComparison']);
	            });
	            /* #endregion */
	        }
	    }]);
	
	    return Controller;
	}(_controller2.default);
	
	exports.default = Controller;

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(1024);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Rowan de Zeeuw on 07/09/2018. Used source code from
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Backbase CXPContentWidget to create this extendable version.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Author : Backbase R&D - Amsterdam - New York
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Filename : content.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Description:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Source code for CXP Universal Content Widget
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var bd = window.bd; /* eslint-disable-line no-unused-vars */
	var be = window.be; /* eslint-disable-line no-unused-vars */
	var $ = window.jQuery;
	
	var AbstractIceContentController = function (_AbstractWidgetBaseCo) {
	    _inherits(AbstractIceContentController, _AbstractWidgetBaseCo);
	
	    function AbstractIceContentController(widget) {
	        _classCallCheck(this, AbstractIceContentController);
	
	        //if (be.ice && bd && bd.designMode == 'true') {
	        var _this = _possibleConstructorReturn(this, (AbstractIceContentController.__proto__ || Object.getPrototypeOf(AbstractIceContentController)).call(this, widget));
	
	        !window.__TEST__ && _this.renderIceWidget();
	        //}
	        return _this;
	    }
	
	    _createClass(AbstractIceContentController, [{
	        key: 'renderIceWidget',
	        value: function renderIceWidget() {
	            var _this2 = this;
	
	            if (!be.ice) {
	                $('img[src=""], img:not([src])', this.widget.body).addClass('be-ice-hide-image');
	                $(this.widget.body).addClass('be-ice-widget-rendered');
	                return;
	            }
	            this.widget.iceConfig = be.ice.config;
	
	            if (this.cxpWidget.canEditContent()) {
	                this.cxpWidget.prepareCxpPreferences();
	
	                var templateUrl = String(this.widget.getPreference('templateUrl'));
	
	                var enableEditing = function enableEditing() {
	                    // it is possible to swap template for editorial
	                    // here is an example for image template
	                    if (templateUrl.match(/\/image\.html$/)) {
	                        templateUrl = templateUrl.replace(/\/image\.html$/, '/image-editorial.html');
	                    }
	
	                    return be.ice.controller.edit(_this2.widget, templateUrl).then(function (dom) {
	                        $(_this2.widget.body).find('.bp-g-include').html(dom.dom);
	                        return dom.dom;
	                    });
	                };
	
	                // this widget has property rendering example (template: simple.html)
	                // so we need to refresh widget after property 'title' modified
	                this.widget.model.addEventListener('PrefModified', function (oEvent) {
	                    if (oEvent.attrName === 'title') {
	                        enableEditing();
	                    }
	                }, false, this.widget);
	
	                enableEditing();
	            } else {
	                $(this.widget.body).addClass('be-ice-widget-rendered');
	            }
	        }
	    }]);
	
	    return AbstractIceContentController;
	}(_controller2.default);
	
	exports.default = AbstractIceContentController;

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cxpConfig = __webpack_require__(1025);
	
	var _cxpConfig2 = _interopRequireDefault(_cxpConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AbstractWidgetBaseController = function () {
	    function AbstractWidgetBaseController(widget) {
	        _classCallCheck(this, AbstractWidgetBaseController);
	
	        this.widget = widget;
	        this.widgetPath = window.App.Portal.getWidgetPath(this.widget);
	        this.cxpWidget = new _cxpConfig2.default(widget);
	    }
	
	    _createClass(AbstractWidgetBaseController, [{
	        key: 'getSelector',
	        value: function getSelector(query) {
	            return this.widget.body.querySelector(query);
	        }
	    }, {
	        key: 'getSelectors',
	        value: function getSelectors(query) {
	            return this.widget.body.querySelectorAll(query);
	        }
	    }]);
	
	    return AbstractWidgetBaseController;
	}();
	
	exports.default = AbstractWidgetBaseController;

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window, App */
	
	
	var _containers = __webpack_require__(358);
	
	var _spacings = __webpack_require__(357);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable-next-line no-unused-vars */
	var bd = window.bd;
	/* eslint-disable-next-line no-unused-vars */
	var be = window.be;
	/* eslint-disable-next-line no-unused-vars */
	var b$ = window.b$;
	
	var CxpWidget = function () {
	    function CxpWidget(widget) {
	        _classCallCheck(this, CxpWidget);
	
	        this.widget = widget;
	        this.widgetName = widget.id.replace(/-\d+$/, '');
	
	        this.widget.addEventListener('DOMReady', this.disableClickOnDevelop.bind(this));
	    }
	
	    _createClass(CxpWidget, [{
	        key: 'addHelpTexts',
	        value: function addHelpTexts(propertyKeyTextMap) {
	            var map = Object.keys(propertyKeyTextMap).reduce(function (map, key) {
	                map[key] = { text: propertyKeyTextMap[key] };
	                return map;
	            }, {});
	            this.widget.helpTexts = map;
	        }
	    }, {
	        key: 'onPreferencesSave',
	        value: function onPreferencesSave(event) {
	            // override
	        }
	    }, {
	        key: 'isManageable',
	        value: function isManageable() {
	            var isMasterpage = be && be.utils ? be.utils.module('top.bd.PageMgmtTree.selectedLink')['isMasterPage'] : false;
	            var isInCxpMode = bd.designMode; //Changed be.cmis
	            var isManageable = isInCxpMode && (isMasterpage || this.widget.model.manageable === 'true' || this.widget.model.manageable === '' || this.widget.model.manageable === undefined);
	            return isManageable;
	        }
	    }, {
	        key: 'canEditContent',
	        value: function canEditContent() {
	            /* todo: this is (also) from the backbase content widget, but as I see it, you can only edit the widget if
	            *  you're admin or the creator? Need to check, else change the role here.
	            *  */
	            return this.isManageable() && be.ice.controller && /(?:ADMIN|CREATOR|MANAGER)/.test(this.widget.model.securityProfile);
	        }
	    }, {
	        key: 'prepareCxpPreferences',
	        value: function prepareCxpPreferences() {
	            var _this = this;
	
	            this.widget.addEventListener('preferences-form', function (event) {
	                _this._populatePreferencesForm(event);
	                //*changed
	                if (_this.onCxpPreferencesForm) {
	                    var observer = new MutationObserver(function (mutations) {
	                        var prefForm = document.querySelector('#PreferenceEditorContent');
	                        if (prefForm) {
	                            observer.disconnect();
	                            _this.onCxpPreferencesForm(prefForm);
	                        }
	                    });
	                    observer.observe(document, { attributes: true, childList: true, subtree: true });
	                }
	            });
	            this.widget.addEventListener('preferencesSaved', function (event) {
	                _this.widget.refreshHTML();
	            });
	            this.widget.addEventListener('savePreferenceForm', function (event) {
	                _this.onPreferencesSave(event);
	            });
	        }
	    }, {
	        key: '_populatePreferencesForm',
	        value: function _populatePreferencesForm(event) {
	            var aPrefs = b$.portal.portalModel.filterPreferences(this.widget.model.preferences.array);
	            for (var i = aPrefs.length - 1; i >= 0; i--) {
	                var preferenceItem = aPrefs[i];
	                var prefKey = preferenceItem.name;
	
	                switch (prefKey) {
	                    case _spacings.SPACING_PREF:
	                        this._populateOptions(preferenceItem, _spacings.SPACING_OPTIONS);
	                        break;
	                    case _containers.CONTAINER_PREF:
	                        this._populateOptions(preferenceItem, _containers.CONTAINER_OPTIONS);
	                        break;
	                    default:
	                        this._populateListItems(preferenceItem);
	                }
	            }
	        }
	    }, {
	        key: '_populateOptions',
	        value: function _populateOptions(preferenceItem, options) {
	            preferenceItem.inputType.options = options.map(function (spacing) {
	                return {
	                    label: spacing.label,
	                    value: spacing.value
	                };
	            });
	        }
	    }, {
	        key: '_populateListItems',
	        value: function _populateListItems(preferenceItem) {
	            var prefKey = preferenceItem.name;
	            var sTemplateVariants = this.widget.getPreference(prefKey + 'List');
	
	            if (!sTemplateVariants) {
	                return;
	            }
	
	            var arr = sTemplateVariants.split(',');
	            for (var j = 0, k = 0; j < arr.length; j++, k++) {
	                preferenceItem.inputType.options[k] = {
	                    label: arr[j].trim(),
	                    value: arr[j + 1].trim()
	                };
	                j++;
	            }
	        }
	    }, {
	        key: 'disableClickOnDevelop',
	        value: function disableClickOnDevelop(event) {
	            if (App.Portal.isInDesignMode()) {
	                this.widget.body.querySelectorAll('a').forEach(function (a) {
	                    a.addEventListener('click', function (e) {
	                        return e.preventDefault();
	                    });
	                });
	            }
	        }
	    }]);
	
	    return CxpWidget;
	}();
	
	exports.default = CxpWidget;

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WidgetFundComparisonHelpers = function () {
	    function WidgetFundComparisonHelpers() {
	        _classCallCheck(this, WidgetFundComparisonHelpers);
	    }
	
	    _createClass(WidgetFundComparisonHelpers, [{
	        key: 'getFundIdParameters',
	        value: function getFundIdParameters(location, param) {
	            var urlParams = new URLSearchParams(location);
	            var initialFund = urlParams.get(param);
	            if (initialFund) {
	                return initialFund;
	            }
	            return false;
	        }
	    }, {
	        key: 'toTitleCase',
	        value: function toTitleCase(str) {
	            return str.toLowerCase().split('-').map(function (word) {
	                return word.charAt(0).toUpperCase() + word.slice(1);
	            }).join(' ');
	        }
	        //Chart Functions 
	
	    }, {
	        key: 'wordsToArray',
	        value: function wordsToArray(words, maxTooltipLength) {
	            var lines = [];
	            var str = '';
	            words.forEach(function (word) {
	                if (str.length + word.length + 1 <= maxTooltipLength) {
	                    str += word + ' ';
	                } else {
	                    lines.push(str);
	                    str = word + ' ';
	                }
	            });
	            lines.push(str);
	            return lines;
	        }
	
	        //Return Chart Colors
	
	    }, {
	        key: 'chartColors',
	        value: function chartColors() {
	            return ['rgb(255, 99, 132)', 'rgb(75, 192, 192)', 'rgb(54, 162, 235)'];
	        }
	    }, {
	        key: 'processChartDataPoints',
	        value: function processChartDataPoints(chartData, chartColors) {
	            var fundDataSet = [];
	            for (var i = 0; i < chartData.length; i++) {
	                fundDataSet.push({
	                    label: chartData[i].fundName,
	                    fundCurrency: chartData[i].fundCurr,
	                    backgroundColor: chartColors[i],
	                    borderColor: chartColors[i],
	                    data: chartData[i].fundData,
	                    type: 'line',
	                    pointStyle: 'circle',
	                    hitRadius: 6,
	                    pointRadius: 1,
	                    hoverRadius: 4,
	                    fill: false,
	                    borderWidth: 1
	                });
	            }
	            return fundDataSet;
	        }
	    }, {
	        key: 'createChartLabel',
	        value: function createChartLabel(tooltipItem, myData) {
	            var chartArea = window.fundChart.chartArea;
	            var label = myData.datasets[tooltipItem.datasetIndex].label || '';
	            var currency = myData.datasets[tooltipItem.datasetIndex].fundCurrency || '';
	            if (label) {
	                label += ': ';
	            }
	            var roi = 0;
	            var gainLoss = "";
	            if (currency === "Peso") {
	                roi = (parseFloat(tooltipItem.value) - 10000.00) / 10000.00 * 100;
	                gainLoss = roi > 0 ? '+' + roi.toFixed(2) + '%' : roi.toFixed(2) + '%';
	                label += 'PHP ' + parseFloat(tooltipItem.value).toLocaleString() + ' (' + gainLoss + ')';
	            } else {
	                roi = (parseFloat(tooltipItem.value) - 1000.00) * 0.100;
	                gainLoss = roi > 0 ? '+' + roi.toFixed(2) : '' + roi.toFixed(2);
	                label += 'USD ' + parseFloat(tooltipItem.value).toLocaleString() + ' (' + gainLoss + ')';
	            }
	            if (chartArea.right <= 480) {
	                if (label.length <= 50) {
	                    return [label];
	                }
	                var words = label.split(':');
	                return this.wordsToArray(words, 50);
	            }{
	                return [label];
	            }
	        }
	    }, {
	        key: 'chartConfiguration',
	        value: function chartConfiguration(fundDataSet) {
	            var _this = this;
	
	            var cfg = {
	                data: {
	                    datasets: fundDataSet
	                },
	                options: {
	                    maintainAspectRatio: false,
	                    cutoutPercentage: 60,
	                    layout: {
	                        padding: {
	                            right: 40
	                        }
	                    },
	                    scales: {
	                        xAxes: [{
	                            type: 'time',
	                            distribution: 'series',
	                            offset: true,
	                            time: {
	                                unit: 'day',
	                                displayFormats: {
	                                    'day': 'MMM DD'
	                                }
	                            },
	                            ticks: {
	                                major: {
	                                    enabled: true,
	                                    fontStyle: 'bold'
	                                },
	                                source: 'data',
	                                autoSkip: true,
	                                autoSkipPadding: 10,
	                                maxRotation: 0,
	                                sampleSize: 100
	                            }
	                        }],
	                        yAxes: [{
	                            gridLines: {
	                                drawBorder: false
	                            },
	                            scaleLabel: {
	                                display: true,
	                                labelString: 'Market Value'
	                            }
	                        }]
	                    },
	                    legend: {
	                        position: 'bottom'
	                    },
	                    plugins: {
	                        zoom: {
	                            pan: {
	                                enabled: true,
	                                mode: 'x'
	                            },
	                            zoom: {
	                                enabled: true,
	                                mode: 'x' // or 'x' for "drag" version
	                            }
	                        }
	                    },
	                    tooltips: {
	                        enabled: true,
	                        mode: 'x',
	                        bodyFontSize: 12,
	                        padding: 20,
	                        callbacks: {
	                            label: function label(tooltipItem, myData) {
	                                return _this.createChartLabel(tooltipItem, myData)[0];
	                            },
	                            afterLabel: function afterLabel(tooltipItem, myData) {
	                                return _this.createChartLabel(tooltipItem, myData).splice(1);
	                            }
	                        }
	                    }
	                }
	            };
	
	            return cfg;
	        }
	    }, {
	        key: 'processToolTipDataPoints',
	        value: function processToolTipDataPoints(tooltip) {
	            if (tooltip.dataPoints) {
	                var currentDataPoints = tooltip.dataPoints.filter(function (arr) {
	                    return arr.xLabel == tooltip.title[0];
	                });
	                //get indexof
	                var currentbody = tooltip.body;
	                var newBody = [];
	                var newLabelColors = [];
	                var newLabelTextColors = [];
	
	                for (var i = 0; i < currentDataPoints.length; i++) {
	                    newBody.push(currentbody[tooltip.dataPoints.indexOf(currentDataPoints[i])]);
	                    newLabelColors.push(tooltip.labelColors[tooltip.dataPoints.indexOf(currentDataPoints[i])]);
	                    newLabelTextColors.push(tooltip.labelTextColors[tooltip.dataPoints.indexOf(currentDataPoints[i])]);
	                }
	                tooltip.dataPoints = currentDataPoints;
	                tooltip.body = newBody;
	                tooltip.labelColors = newLabelColors;
	                tooltip.labelTextColors = newLabelTextColors;
	                var chartArea = window.fundChart.chartArea;
	                var labelHeight = 0;
	                if (chartArea.right <= 480) {
	                    labelHeight = currentDataPoints.length * 30;
	                } else {
	                    labelHeight = currentDataPoints.length * 20;
	                }
	                tooltip.height = 22 + labelHeight;
	            }
	        }
	    }, {
	        key: 'loadChart',
	        value: function loadChart(chartData) {
	            var _this2 = this;
	
	            Chart.defaults.global.tooltips.custom = function (tooltip) {
	                _this2.processToolTipDataPoints(tooltip);
	                return;
	            };
	
	            var chartColors = this.chartColors();
	            var ctx = document.getElementById('canvas').getContext('2d');
	
	            var fundDataSet = this.processChartDataPoints(chartData, chartColors);
	            var cfg = this.chartConfiguration(fundDataSet);
	
	            if (window.fundChart !== undefined) {
	                window.fundChart.destroy();
	            }
	            window.fundChart = new Chart(ctx, cfg);
	        }
	    }, {
	        key: 'getAmtcProducts',
	        value: function getAmtcProducts(url, amtcContentProductsPath) {
	            return window.App.Api.GET(url, {
	                params: {
	                    path: amtcContentProductsPath,
	                    provided_id: 1
	                }
	            }).then(function (res) {
	                return Promise.resolve(res);
	            }).catch(function (error) {
	                return Promise.reject(error);
	            });
	        }
	    }, {
	        key: 'getAmtcProductsV2',
	        value: function getAmtcProductsV2(path, processorEndpoint, contentHeaders) {
	            var getContentEndpoint = processorEndpoint;
	            var origin = window.location.origin;
	            var getContentHeaders = "";
	            try {
	                getContentHeaders = JSON.parse(contentHeaders);
	                getContentHeaders.path = origin + path;
	            } catch (e) {
	                console.log("Please check headers");
	            }
	
	            var dataFromStorage = JSON.parse(sessionStorage.getItem("allfundcontent"));
	            if (dataFromStorage) {
	                return Promise.resolve(dataFromStorage);
	            } else {
	                console.log("No cached data");
	                return window.App.Api.GET(getContentEndpoint, {
	                    headers: getContentHeaders
	                }).then(function (res) {
	                    sessionStorage.setItem("allfundcontent", JSON.stringify(res));
	                    return Promise.resolve(res);
	                }).catch(function (error) {
	                    return Promise.reject(error);
	                });
	            }
	        }
	    }, {
	        key: 'apiRequestCanceller',
	        value: function apiRequestCanceller() {
	            console.log("Cancelled!");
	        }
	    }, {
	        key: 'startSession',
	        value: function startSession(url, startheaders) {
	            return window.App.Api.GET(url, { headers: startheaders }).then(function (res) {
	                return Promise.resolve(res);
	            }).catch(function (error) {
	                return Promise.reject(error);
	            });
	        }
	    }, {
	        key: 'getMarketValue',
	        value: function getMarketValue(fundIds, investmentTerm, url) {
	            var _this3 = this;
	
	            //return Promise.resolve(JSON.parse(localStorage.getItem("mockData2")));
	            var compareHeaders = {
	                intSvcName: "sis/amtc",
	                service: "fundComparisonAPI",
	                investmentTerm: investmentTerm,
	                transactionId: sessionStorage.getItem("s_key")
	            };
	            if (fundIds.length === 2) {
	                compareHeaders.fundId_1 = fundIds[0];
	                compareHeaders.fundId_2 = fundIds[1];
	            } else if (fundIds.length === 3) {
	                compareHeaders.fundId_1 = fundIds[0];
	                compareHeaders.fundId_2 = fundIds[1];
	                compareHeaders.fundId_3 = fundIds[2];
	            }
	            return window.App.Api.GET(url, {
	                headers: compareHeaders,
	                cancelGetter: function cancelGetter(canceller) {
	                    return _this3.apiRequestCanceller = canceller;
	                }
	            }).then(function (res) {
	                return Promise.resolve(res);
	            }).catch(function (error) {
	                console.log("Cancelled! 1");
	                return Promise.reject(error);
	            });
	        }
	    }]);
	
	    return WidgetFundComparisonHelpers;
	}();
	
	exports.default = WidgetFundComparisonHelpers;

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

	module.exports = "<div class=\"widget-amtc-fund-comparison form-application-page\">\n    <div id=\"main\" class=\"widget-amtc-fund-comparison__container\">\n        <form name=\"frmFundComparison\">\n            <div class=\"widget-amtc-fund-comparison__container-top-layer\"></div>\n            <div class=\"form-fields__field currency-wrapper\">\n                <label class=\"input-wrapper__label\"><span class=\"label__text\">{{chooseCurrencyText}}</span></label>\n                <div class=\"input-group\">\n                    <button class=\"btn btn-currency btn-secondary\" ng-class=\"{active:currency=='Peso'}\" ng-click=\"checkPreselected('Peso')\">Peso</button>\n                    <button class=\"btn btn-currency btn-secondary\" ng-class=\"{active:currency=='Dollar'}\" ng-click=\"checkPreselected('Dollar')\">Dollar</button>\n                    <div class=\"default-loader\" ng-show=\"defaultLoader\">\n                        <div class=\"default-spinner\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-fields__field fund-wrapper\">\n                <label class=\"currency-wrapper\" ng-show=\"selectedFundComps.length==0\"><span>{{chooseFundsText}}</span></label>\n                <label class=\"currency-wrapper\" ng-show=\"selectedFundComps.length>=1 && selectedFundComps.length<=2\"><span>You are comparing {{selectedFundComps[0].assetClass | toTitleCase}}, please select another fund or </span><span class=\"btn-clear-selections\" ng-click=\"removeFund('all')\">clear your selections.</span></label>\n                <label class=\"currency-wrapper\" ng-show=\"selectedFundComps.length==3\"><span>You are comparing {{selectedFundComps[0].assetClass | toTitleCase}}, </span><span class=\"btn-clear-selections\" ng-click=\"removeFund('all')\">clear your selections.</span></label>\n                <table>\n                    <tr>\n                        <td>\n                            <div class=\"form-group\" ng-hide=\"selectedFundComps[0]!=undefined\">\n                                <div class=\"input-wrapper pristine\">\n                                    <div class=\"input-group \">\n                                        <div class=\"select-input\"  ng-class=\"{'disable-dropdown':currency==''}\" tabindex=\"0\" id=\"inputRiskProfile\"\n                                            ng-click=\"toggleDisplayFirstFund()\" ng-blur=\"toggleDisplayFirstFund(true)\">\n                                            <select class=\"select-input__select-input\" placeholder=\"Choose Profile\"\n                                                id=\"ddRiskProfile\" ng-model=\"selectedRiskProfile\">\n                                                <option value=\"\"></option>\n                                            </select>\n        \n                                            <div class=\"form-control select-input__fake-input placeholder\">\n                                                <div class=\"select-input__fake-input-label-wrapper\">\n                                                    <div class=\"select-input__fake-input-label\">{{ddDefaultText}}</div>\n                                                </div>\n                                            </div>\n                                            <div class=\"select-input__dropdown\" id=\"comp-risk-profile\" ng-show=\"showRiskList\">\n                                                <ul id=\"select-risk-profile\">\n                                                    <li class=\"dd-category\" ng-repeat=\"assetClass in assetClasses | orderBy: 'order'\">\n                                                            <div class=\"fund-class-text\">{{assetClass.fundClassText}}</div>\n                                                        <ul>\n                                                            <li class=\"dd-items\" ng-repeat=\"fund in assetClass.funds\" ng-click=\"setSelected(fund)\">\n                                                                <div>\n                                                                {{fund.nameOfFund}}</div></li>\n                                                        </ul>\n                                                    </li>\n                                                </ul>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"product-name-box\" ng-show=\"selectedFundComps[0].nameOfFund!=undefined\">\n                                <div class=\"wid-alert-bar__close\" ng-click=\"removeFund(0)\"></div>\n                                <div class=\"product-name\">{{selectedFundComps[0].nameOfFund}}</div>\n                            </div>\n                        </td>\n                        <td>\n                            <div class=\"form-group\" ng-hide=\"selectedFundComps[1]!=undefined\">\n                                <div class=\"input-wrapper pristine\">\n                                    <div class=\"input-group\">\n                                        <div class=\"select-input\" ng-class=\"{'disable-dropdown':selectedFundComps.length<1}\" tabindex=\"1\" id=\"inputFundClass\" ng-click=\"toggleDisplaySecondSelect()\" ng-blur=\"toggleDisplaySecondSelect(true)\">\n                                            <div ng-class=\"{'form-control':showSecondDropdown, 'select-input__fake-input':showSecondDropdown, 'placeholder':showSecondDropdown}\">\n                                                <div ng-hide=\"showSecondDropdown\" class=\"add-fund-default\"><div>+</div></div>\n                                                <div ng-show=\"showSecondDropdown\" class=\"select-input__fake-input-label-wrapper\">\n                                                    <div class=\"select-input__fake-input-label\">{{ddDefaultText}}</div>\n                                                </div>\n                                            </div>\n                                            <div class=\"select-input__dropdown\" id=\"comp-fund-class\" ng-show=\"showFundClass\">\n                                                <ul id=\"select-fund-class\">\n                                                    <li class=\"dd-category\" ng-show=\"secondDropDownFunds[0].funds.length<1\">\n                                                        <div class=\"fund-class-text\">{{cantCompareText}}</div>\n                                                        <ul></ul>\n                                                    </li>\n                                                    <li class=\"dd-category\" ng-show=\"secondDropDownFunds[0].funds.length>0\" ng-repeat=\"assetClass in secondDropDownFunds | orderBy: 'order'\">\n                                                        <div class=\"fund-class-text\">{{assetClass.fundClassText}}</div>\n                                                        <ul>\n                                                            <li class=\"dd-items\" ng-repeat=\"fund in assetClass.funds\" ng-click=\"setSelected(fund)\">\n                                                                <div>\n                                                                {{fund.nameOfFund}}</div></li>\n                                                        </ul>\n                                                    </li>\n                                                </ul>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"product-name-box\" ng-show=\"selectedFundComps[1].nameOfFund!=undefined\">\n                                <div class=\"wid-alert-bar__close\" ng-click=\"removeFund(1)\"></div>\n                                <div class=\"product-name\">{{selectedFundComps[1].nameOfFund}}</div>\n                            </div>\n                        </td>\n                        <td>\n                            <div class=\"form-group\" ng-hide=\"selectedFundComps[2]!=undefined\">\n                                <div class=\"input-wrapper pristine\"> \n                                    <div class=\"input-group\">\n                                        <div class=\"select-input\" ng-class=\"{'disable-dropdown':selectedFundComps.length<2}\" tabindex=\"2\" id=\"inputFundToCompare\" ng-click=\"toggleDisplayThirdSelect()\" ng-blur=\"toggleDisplayThirdSelect(true)\">\n                                            <div ng-class=\"{'form-control':showThirdDropdown, 'select-input__fake-input':showThirdDropdown, 'placeholder':showThirdDropdown}\">\n                                                <div ng-hide=\"showThirdDropdown\" class=\"add-fund-default\"><div>+</div></div>\n                                                <div ng-show=\"showThirdDropdown\" class=\"select-input__fake-input-label-wrapper\">\n                                                    <div class=\"select-input__fake-input-label\">{{ddDefaultText}}</div>\n                                                </div>\n                                            </div>\n                                            <div class=\"select-input__dropdown\" id=\"comp-funds-to-compare\" ng-show=\"showFunds\">\n                                                <ul id=\"select-fund-to-compare\">\n                                                    <li class=\"dd-category\" ng-show=\"thirdDropDownFunds[0].funds.length<1\">\n                                                        <div class=\"fund-class-text\">{{cantCompareText}}</div>\n                                                        <ul></ul>\n                                                    </li>\n                                                    <li class=\"dd-category\" ng-show=\"thirdDropDownFunds[0].funds.length>0\" ng-repeat=\"assetClass in thirdDropDownFunds | orderBy: 'order'\">\n                                                        <div class=\"fund-class-text\">{{assetClass.fundClassText}}</div>\n                                                    <ul>\n                                                        <li class=\"dd-items\" ng-repeat=\"fund in assetClass.funds\" ng-click=\"setSelected(fund)\">\n                                                            <div>\n                                                            {{fund.nameOfFund}}</div></li>\n                                                    </ul>\n                                                </li>\n                                                </ul>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"product-name-box\" ng-show=\"selectedFundComps[2].nameOfFund!=undefined\">\n                                <div class=\"wid-alert-bar__close\" ng-click=\"removeFund(2)\"></div>\n                                <div class=\"product-name\">{{selectedFundComps[2].nameOfFund}}</div>\n                            </div>\n                        </td>\n                    </tr>\n                    <tr ng-hide=\"selectedFundComps[0].nameOfFund==undefined\">\n                        <td colspan=\"3\"><span class=\"product-title\">Brief Description</span></td>                        \n                    </tr>\n                    <tr class=\"fund-info\">\n                        <td ng-class=\"{'content-line':selectedFundComps[0].nameOfFund!=undefined}\">\n                                <div ng-show=\"selectedFundComps[0].nameOfFund!=undefined\">{{selectedFundComps[0].shortDescription}}<br /> <a target=\"_blank\" href=\"{{selectedFundComps[0].learnMoreLink}}\">Learn more</a></div>\n                        </td>\n                        <td ng-class=\"{'content-line':selectedFundComps[1].nameOfFund!=undefined}\">\n                                <div ng-show=\"selectedFundComps[1].nameOfFund!=undefined\">{{selectedFundComps[1].shortDescription}}<br /> <a target=\"_blank\" href=\"{{selectedFundComps[1].learnMoreLink}}\">Learn more</a></div>\n                        </td>\n                        <td ng-class=\"{'content-line':selectedFundComps[2].nameOfFund!=undefined}\">\n                                <div ng-show=\"selectedFundComps[2].nameOfFund!=undefined\">{{selectedFundComps[2].shortDescription}}<br /> <a target=\"_blank\" href=\"{{selectedFundComps[2].learnMoreLink}}\">Learn more</a></div>\n                        </td>\n                    </tr>\n                    <tr ng-hide=\"selectedFundComps[0].nameOfFund==undefined\">\n                        <td colspan=\"3\"><span class=\"product-title\">Risk Profile</span> </td>\n                    </tr>\n                    <tr class=\"fund-info\">\n                        <td ng-class=\"{'content-line':selectedFundComps[0].nameOfFund!=undefined}\">  \n                            {{selectedFundComps[0].riskCategory | toTitleCase}}\n                        </td>\n                        <td ng-class=\"{'content-line':selectedFundComps[1].nameOfFund!=undefined}\">\n                            {{selectedFundComps[1].riskCategory | toTitleCase}}\n                        </td >\n                        <td ng-class=\"{'content-line':selectedFundComps[2].nameOfFund!=undefined}\">\n                            {{selectedFundComps[2].riskCategory | toTitleCase}}\n                        </td>\n                    </tr>\n                    <tr ng-hide=\"selectedFundComps[0].nameOfFund==undefined\">\n                        <td colspan=\"3\"><span class=\"product-title\">Minimum Investment Amount</span></td>                        \n                    </tr>\n                    <tr class=\"fund-info\"> \n                        <td ng-class=\"{'content-line':selectedFundComps[0].nameOfFund!=undefined}\">{{selectedFundComps[0].baseCurrency == \"Peso\" ? \"PHP \": selectedFundComps[0].baseCurrency ==\n                            \"Dollar\"? \"USD \":\"\"}}{{selectedFundComps[0].minimumInitialInvestment | number:0}}</td>\n                        <td ng-class=\"{'content-line':selectedFundComps[1].nameOfFund!=undefined}\">{{selectedFundComps[1].baseCurrency == \"Peso\" ?\"PHP \":selectedFundComps[1].baseCurrency ==\n                            \"Dollar\"?\"USD \":\"\"}}{{selectedFundComps[1].minimumInitialInvestment | number:0}}</td>\n                        <td ng-class=\"{'content-line':selectedFundComps[2].nameOfFund!=undefined}\">{{selectedFundComps[2].baseCurrency == \"Peso\" ?\"PHP \":selectedFundComps[2].baseCurrency ==\n                            \"Dollar\"?\"USD \":\"\"}}{{selectedFundComps[2].minimumInitialInvestment | number:0}}</td>\n                    </tr>\n                    <tr ng-hide=\"selectedFundComps[0].nameOfFund==undefined\">\n                        <td colspan=\"3\"><span class=\"product-title\">Minimum Transaction Amount</span></td>\n                    </tr>\n                    <tr class=\"fund-info\">\n                        <td ng-class=\"{'content-line':selectedFundComps[0].nameOfFund!=undefined}\">{{selectedFundComps[0].baseCurrency == \"Peso\" ?\"PHP \":selectedFundComps[0].baseCurrency ==\n                            \"Dollar\"?\"USD \":\"\"}}{{selectedFundComps[0].minimumTransactionAmount | number:0}}</td>\n                        <td ng-class=\"{'content-line':selectedFundComps[1].nameOfFund!=undefined}\">{{selectedFundComps[1].baseCurrency == \"Peso\" ?\"PHP \":selectedFundComps[1].baseCurrency ==\n                            \"Dollar\"?\"USD \":\"\"}}{{selectedFundComps[1].minimumTransactionAmount | number:0}}</td>\n                        <td ng-class=\"{'content-line':selectedFundComps[2].nameOfFund!=undefined}\">{{selectedFundComps[2].baseCurrency == \"Peso\" ?\"PHP \":selectedFundComps[2].baseCurrency ==\n                            \"Dollar\"?\"USD \":\"\"}}{{selectedFundComps[2].minimumTransactionAmount | number:0}}</td>\n                    </tr>\n                    <tr ng-hide=\"selectedFundComps[0].nameOfFund==undefined\">\n                        <td colspan=\"3\"><span class=\"product-title\">Trust Fee</span></td>                        \n                    </tr>\n                    <tr class=\"fund-info\">\n                        <td ng-class=\"{'content-line':selectedFundComps[0].nameOfFund!=undefined}\">{{selectedFundComps[0].trustFee}}</td>\n                        <td ng-class=\"{'content-line':selectedFundComps[1].nameOfFund!=undefined}\">{{selectedFundComps[1].trustFee}}</td>\n                        <td ng-class=\"{'content-line':selectedFundComps[2].nameOfFund!=undefined}\">{{selectedFundComps[2].trustFee}}</td>\n                    </tr>\n                </table>\n            <!--mobile View-->\n                <div class=\"row fund-dd-wrapper\">\n                    <div class=\"form-group col-md-4\" ng-hide=\"selectedFundComps[0]!=undefined\">\n                        <div class=\"input-wrapper pristine\">\n                            <div class=\"input-group \">\n                                <div class=\"select-input\" ng-class=\"{'disable-dropdown':currency==''}\" tabindex=\"0\" id=\"inputRiskProfile\"\n                                    ng-click=\"toggleDisplayFirstFund()\" ng-blur=\"toggleDisplayFirstFund(true)\">\n                                    <select class=\"select-input__select-input\" placeholder=\"Choose Profile\"\n                                        id=\"ddRiskProfile\" ng-model=\"selectedRiskProfile\">\n                                        <option value=\"\"></option>\n                                    </select>\n\n                                    <div class=\"form-control select-input__fake-input placeholder\">\n                                        <div class=\"select-input__fake-input-label-wrapper\"\n                                            ng-init=\"selectedRiskProfileText='Choose a fund'\">\n                                            <div class=\"select-input__fake-input-label\">{{ddDefaultText}}</div>\n                                        </div>\n                                    </div>\n                                    <div class=\"select-input__dropdown\" id=\"comp-risk-profile\" ng-show=\"showRiskList\">\n                                        <ul id=\"select-risk-profile\">\n                                            <li class=\"dd-category\" ng-repeat=\"assetClass in assetClasses | orderBy: 'order'\">\n                                                <div class=\"fund-class-text\">{{assetClass.fundClassText}}</div>\n                                                <ul>\n                                                    <li class=\"dd-items\" ng-repeat=\"fund in assetClass.funds\" ng-click=\"setSelected(fund)\">\n                                                        <div>\n                                                        {{fund.nameOfFund}}</div></li>\n                                                </ul>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-md-4 fund-result column-info\" ng-show=\"selectedFundComps[0]!=undefined\">\n                        <div class=\"product-name-box\" ng-show=\"selectedFundComps[0].nameOfFund!=undefined\">\n                            <div class=\"wid-alert-bar__close\" ng-click=\"removeFund(0)\"></div>\n                            <div class=\"product-name\">{{selectedFundComps[0].nameOfFund}}</div>\n                        </div>\n                        <div class=\"product-title\">Brief Description</div>\n                        <div class=\"fund-description\">\n                            <div ng-show=\"selectedFundComps[0].nameOfFund!=undefined\">{{selectedFundComps[0].shortDescription}} <a target=\"_blank\" href=\"{{selectedFundComps[0].learnMoreLink}}\">Learn more</a></div>\n                        </div>\n                        <div ng-class=\"{'toggle-hide':!showThis[0],'toggle-show':showThis[0]}\">\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Risk Profile</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[0].riskCategory | toTitleCase}}</div>\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Minimum Investment Amount</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[0].baseCurrency == \"Peso\" ?\"PHP\":selectedFundComps[0].baseCurrency ==\n                                    \"Dollar\"?\"USD\":\"\"}}{{selectedFundComps[0].minimumInitialInvestment | number:0}}</div>\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Minimum Transaction Amount</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[0].baseCurrency == \"Peso\" ?\"PHP\":selectedFundComps[0].baseCurrency ==\n                                    \"Dollar\"?\"USD\":\"\"}}{{selectedFundComps[0].minimumInitialInvestment | number:0}}</div>\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Trust Fee</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[0].trustFee}}</div>\n                            </div>\n                        </div>\n                        <div class=\"details-toggle\" ng-click=\"toggleDetails(0)\">\n                            {{showThis[0] ? \"Show less\":\"Show more\"}}\n                        </div>\n                    </div>\n\n                    <div class=\"form-group col-md-4\" ng-hide=\"selectedFundComps[1]!=undefined\">\n                        <div class=\"input-wrapper pristine\">\n                            <div class=\"input-group\">\n                                <div class=\"select-input\" ng-class=\"{'disable-dropdown':selectedFundComps.length<1}\" tabindex=\"1\" id=\"inputFundClass\" ng-click=\"toggleDisplaySecondSelect()\" ng-blur=\"toggleDisplaySecondSelect(true)\">\n                                    <div ng-class=\"{'form-control':showSecondDropdown, 'select-input__fake-input':showSecondDropdown, 'placeholder':showSecondDropdown}\">\n                                        <div ng-hide=\"showSecondDropdown\" class=\"add-fund-default\"><div>+</div></div>\n                                        <div ng-show=\"showSecondDropdown\" class=\"select-input__fake-input-label-wrapper\">\n                                            <div class=\"select-input__fake-input-label\">{{ddDefaultText}}</div>\n                                        </div>\n                                    </div>\n                                    <div class=\"select-input__dropdown\" id=\"comp-fund-class\" ng-show=\"showFundClass\">\n                                        <ul id=\"select-fund-class\">\n                                            <li class=\"dd-category\" ng-show=\"secondDropDownFunds[0].funds.length<1\">\n                                                <div class=\"fund-class-text\">{{cantCompareText}}</div>\n                                                <ul></ul>\n                                            </li>\n                                            <li class=\"dd-category\" ng-show=\"secondDropDownFunds[0].funds.length>0\" ng-repeat=\"assetClass in secondDropDownFunds | orderBy: 'order'\">\n                                                <div class=\"fund-class-text\">{{assetClass.fundClassText}}</div>\n                                            <ul>\n                                                <li class=\"dd-items\" ng-repeat=\"fund in assetClass.funds\" ng-click=\"setSelected(fund)\">\n                                                    <div>\n                                                    {{fund.nameOfFund}}</div></li>\n                                            </ul>\n                                        </li>\n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-md-4 fund-result\" ng-class=\"{'column-info':enableTransition,'closed':closeIndex1}\" ng-show=\"selectedFundComps[1]!=undefined\">\n                        <div class=\"product-name-box\" ng-show=\"selectedFundComps[1].nameOfFund!=undefined\">\n                            <div class=\"wid-alert-bar__close\" ng-click=\"removeFund(1)\"></div>\n                            <div class=\"product-name\">{{selectedFundComps[1].nameOfFund}}</div>\n                        </div>\n                        <div class=\"product-title\">Brief Description</div>\n                        <div class=\"fund-description\">\n                            <div ng-show=\"selectedFundComps[1].nameOfFund!=undefined\">{{selectedFundComps[1].shortDescription}} <a target=\"_blank\" href=\"{{selectedFundComps[1].learnMoreLink}}\">Learn more</a></div>\n                        </div>\n                        <div ng-class=\"{'toggle-hide':!showThis[1],'toggle-show':showThis[1]}\">\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Risk Profile</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[1].riskCategory | toTitleCase}}</div>\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Minimum Investment Amount</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[1].baseCurrency == \"Peso\" ?\"PHP\":selectedFundComps[1].baseCurrency ==\n                                    \"Dollar\"?\"USD\":\"\"}}{{selectedFundComps[1].minimumInitialInvestment | number:0}}</div>\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Minimum Transaction Amount </div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[1].baseCurrency == \"Peso\" ?\"PHP\":selectedFundComps[1].baseCurrency ==\n                                    \"Dollar\"?\"USD\":\"\"}}{{selectedFundComps[1].minimumInitialInvestment | number:0}}</div>\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Trust Fee</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[1].trustFee}}</div>\n                            </div>\n                        </div>\n                        <div class=\"details-toggle\" ng-click=\"toggleDetails(1)\">\n                            {{showThis[1] ? \"Show less\":\"Show more\"}}\n                        </div>\n                    </div>\n\n\n                    <div class=\"form-group col-md-4\" ng-hide=\"selectedFundComps[2]!=undefined\">\n                        <div class=\"input-wrapper pristine\"> \n                            <div class=\"input-group\">\n                                <div class=\"select-input\" ng-class=\"{'disable-dropdown':selectedFundComps.length<2}\" tabindex=\"2\" id=\"inputFundToCompare\" ng-click=\"toggleDisplayThirdSelect()\" ng-blur=\"toggleDisplayThirdSelect(true)\">\n                                    <div ng-class=\"{'form-control':showThirdDropdown, 'select-input__fake-input':showThirdDropdown, 'placeholder':showThirdDropdown}\">\n                                        <div ng-hide=\"showThirdDropdown\" class=\"add-fund-default\"><div>+</div></div>\n                                        <div ng-show=\"showThirdDropdown\" class=\"select-input__fake-input-label-wrapper\">\n                                            <div class=\"select-input__fake-input-label\">{{ddDefaultText}}</div>\n                                        </div>\n                                    </div>\n                                    <div class=\"select-input__dropdown\" id=\"comp-funds-to-compare\" ng-show=\"showFunds\">\n                                        <ul id=\"select-fund-to-compare\">\n                                            <li class=\"dd-category\" ng-show=\"thirdDropDownFunds[0].funds.length<1\">\n                                                <div class=\"fund-class-text\">{{cantCompareText}}</div>\n                                                <ul></ul>\n                                            </li>\n                                            <li class=\"dd-category\" ng-show=\"thirdDropDownFunds[0].funds.length>0\" ng-repeat=\"assetClass in thirdDropDownFunds | orderBy: 'order'\">\n                                                <div class=\"fund-class-text\">{{assetClass.fundClassText}}</div>\n                                            <ul>\n                                                <li class=\"dd-items\" ng-repeat=\"fund in assetClass.funds\" ng-click=\"setSelected(fund)\">\n                                                    <div>\n                                                    {{fund.nameOfFund}}</div></li>\n                                            </ul>\n                                        </li>\n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-md-4 fund-result\" ng-class=\"{'column-info':enableTransition,'closed':closeIndex2}\" ng-show=\"selectedFundComps[2]!=undefined\">\n                        <div class=\"product-name-box\" ng-show=\"selectedFundComps[1].nameOfFund!=undefined\">\n                            <div class=\"wid-alert-bar__close\" ng-click=\"removeFund(2)\"></div>\n                            <div class=\"product-name\">{{selectedFundComps[2].nameOfFund}}</div>\n                        </div>\n                        <div class=\"product-title\">Brief Description</div>\n                        <div class=\"fund-description\">\n                            <div ng-show=\"selectedFundComps[2].nameOfFund!=undefined\">{{selectedFundComps[2].shortDescription}} <a target=\"_blank\" href=\"{{selectedFundComps[2].learnMoreLink}}\">Learn more</a></div>\n                        </div>\n                        <div ng-class=\"{'toggle-hide':!showThis[2],'toggle-show':showThis[2]}\">\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Risk Profile</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[2].riskCategory | toTitleCase}}</div>\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Minimum Investment Amount</div>\n                            <div class=\"fund-info\">\n                                <div>{{selectedFundComps[2].baseCurrency == \"Peso\" ?\"PHP\":selectedFundComps[2].baseCurrency ==\n                                    \"Dollar\"?\"USD\":\"\"}}{{selectedFundComps[2].minimumInitialInvestment | number:0}}</div>\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Minimum Transaction Amount</div>\n                            <div class=\"fund-info\">\n                                {{selectedFundComps[2].baseCurrency == \"Peso\" ?\"PHP\":selectedFundComps[2].baseCurrency ==\n                                    \"Dollar\"?\"USD\":\"\"}}{{selectedFundComps[2].minimumInitialInvestment | number:0}}\n                            </div>\n                            <div class=\"content-line-mob\"></div>\n                            <div class=\"product-title\">Trust Fee</div>\n                            <div class=\"fund-info\">\n                                {{selectedFundComps[2].trustFee}}\n                            </div>\n                        </div>\n                        <div class=\"details-toggle\" ng-click=\"toggleDetails(2)\">\n                                {{showThis[2] ? \"Show less\":\"Show more\"}}\n                        </div>\n                    </div>\n                </div>\n                <div class=\"compare-btn-cont\" ng-show=\"selectedFundComps.length>1\">\n                    <button class=\"btn btn-secondary btn-compare\" ng-class=\"{active:showTable}\"\n                        ng-click=\"selectedFundComps.length>1 && compareFunds(0)\" ng-show=\"displayShowGraphBtn\">Show Graph</button>\n                    <button class=\"btn btn-secondary btn-compare\" ng-class=\"{active:showTable}\"\n                        ng-click=\"hideChartClick()\"  ng-disabled=\"blockCall\" ng-show=\"!displayShowGraphBtn\">Hide Graph</button>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class=\"fund-modal-container\" ng-show=\"showDialog\">\n        <div class=\"fund-modal-content\">\n            <div class=\"fund-modal-content-cont\">\n                <div class=\"fund-modal-close\">\n                    <div class=\"wid-alert-bar__close\" ng-click=\"closeDialog(false)\"></div>\n                </div>\n                <div class=\"fund-modal-body\">\n                    All fields will be refreshed, would you like to proceed?\n                </div>\n                <div class=\"fund-modal-buttons\">\n                    <button class=\"btn btn-primary\" ng-click=\"closeDialog(true)\">Yes</button><button\n                        class=\"btn btn-primary\" ng-click=\"closeDialog(false)\">No</button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"fund-modal-container\" ng-show=\"showDialogCompare0\">\n        <div class=\"fund-modal-content\">\n            <div class=\"fund-modal-content-cont\">\n                <div class=\"fund-modal-body\">\n                    Please note that {{fundNameComp0}} does not have a {{fundHorizonComp0 | pluralizedYear}} data\n                    available\n                    as its inception date is {{fundInceptionDateComp0}}.\n                </div>\n                <div class=\"fund-modal-buttons\">\n                    <button class=\"btn btn-primary\" id=\"dYes\" ng-click=\"closeDialogCompare(0)\">Ok</button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"fund-modal-container\" ng-show=\"showDialogCompare1\">\n        <div class=\"fund-modal-content\">\n            <div class=\"fund-modal-content-cont\">\n                <div class=\"fund-modal-body\">\n                    Please note that {{fundNameComp1}} does not have a {{fundHorizonComp1 | pluralizedYear}} data\n                    available\n                    as its inception date is {{fundInceptionDateComp1}}.\n                </div>\n                <div class=\"fund-modal-buttons\">\n                    <button class=\"btn btn-primary\" id=\"dYes\" ng-click=\"closeDialogCompare(1)\">Ok</button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"fund-modal-container\" ng-show=\"showDialogCompare2\">\n        <div class=\"fund-modal-content\">\n            <div class=\"fund-modal-content-cont\">\n                <div class=\"fund-modal-body\">\n                    Please note that {{fundNameComp2}} does not have a {{fundHorizonComp2 | pluralizedYear}} data\n                    available\n                    as its inception date is {{fundInceptionDateComp2}}.\n                </div>\n                <div class=\"fund-modal-buttons\">\n                    <button class=\"btn btn-primary\" id=\"dYes\" ng-click=\"closeDialogCompare(2)\">Ok</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"widget-amtc-fund-comparison form-application-page bottom-fold\"\n    ng-show=\"selectedFundComps.length>1 && showTable\">\n    <div id=\"main\" class=\"widget-amtc-fund-comparison__container\">\n        <div class=\"widget-amtc-fund-comparison__container-top-layer\"></div>\n\n        <div class=\"fund-buttons-container\">\n            <button class=\"btn\" ng-class=\"{ 'btn-default': ytdDef, 'btn-secondary active': ytd }\" ng-click=\"compareFunds(0)\"\n                ng-disabled=\"blockCall\">Year\n                To Date</button>\n            <button class=\"btn\" ng-class=\"{ 'btn-default': oneYearDef, 'btn-secondary active': oneYear }\"\n                ng-click=\"compareFunds(1)\" ng-disabled=\"blockCall\">1 Yr</button>\n            <button class=\"btn\" ng-class=\"{ 'btn-default': threeYearsDef, 'btn-secondary active': threeYears }\"\n                ng-click=\"compareFunds(3)\" ng-disabled=\"blockCall\">3 Yrs</button>\n            <button class=\"btn\" ng-class=\"{ 'btn-default': fiveYearsDef, 'btn-secondary active': fiveYears }\"\n                ng-click=\"compareFunds(5)\" ng-disabled=\"blockCall\">5 Yrs</button>\n        </div>\n        <div ng-show=\"hideChart\">Graph not available for fund {{ fundName }}. Please select other funds to compare</div>\n        <div class=\"chart-cont\" ng-hide=\"hideChart\">\n            <div id=\"chart-loader\" ng-show=\"displayLoader\">\n                <div class=\"chart-spinner\"></div>\n            </div>\n            <div class=\"chartjs-size-monitor\">\n                <div class=\"chartjs-size-monitor-expand\">\n                    <div class=\"\"></div>\n                </div>\n                <div class=\"chartjs-size-monitor-shrink\">\n                    <div class=\"\"></div>\n                </div>\n            </div>\n            <canvas id=\"canvas\" class=\"chartjs-render-monitor\"></canvas>\n            <div id=\"chartjs-tooltip\"></div>\n        </div>\n    </div>\n\n</div>"

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// widget-amtc-fund-comparison/scripts/widget-amtc-fund-comparison.js